exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.scenario-error-footer-contents[data-v-793e101c] {\n  width: 100%;\n}\n.scenario-error-footer-contents .error-contents[data-v-793e101c] {\n    margin-top: 8px;\n    padding: 0 16px;\n    width: 100%;\n    font-size: 14px;\n}\n.scenario-error-footer-contents h3[data-v-793e101c] {\n    font-weight: bold;\n    color: red;\n}\n.scenario-error-footer-contents article[data-v-793e101c] {\n    margin-top: 8px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-793e101c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/molecules/chatbot/footers/ScenarioErrorFooterContents.vue
// module id = sL01
// module chunks = 3